module.exports = __webpack_public_path__ + "static/img/sta2.8c559f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/sta2.png
// module id = bj+n
// module chunks = 1